import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { ALLOWED_ROLES } from "../api/url";
import { useAuthModal } from "../context/authModalContext";

const AdminPrivateRoute = ({ children }) => {
  // Gate on the user's identity token, not the DMS service token. The DMS
  // token may not exist yet (Lisa's case — her metadata carries no generic
  // credentials so the post-login generic swap is skipped) even though the
  // user is fully authenticated against Identity/Auth.
  const token = localStorage.getItem("vizy-identity-token");
  const { openModal } = useAuthModal();

  useEffect(() => {
    if (!token) openModal("login");
  }, [token, openModal]);

  if (!token) return <Navigate to="/" replace />;

  try {
    const clientInfo = JSON.parse(localStorage.getItem("client_info") || "null");
    if (!clientInfo) return <Navigate to="/" replace />;

    const rawRole =
      clientInfo.role ||
      clientInfo.appType ||
      clientInfo["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    const roles = Array.isArray(rawRole) ? rawRole : rawRole ? [rawRole] : [];
    const hasAccess = roles.some((r) => ALLOWED_ROLES.includes(r));

    return hasAccess ? children : <Navigate to="/" replace />;
  } catch {
    return <Navigate to="/" replace />;
  }
};

export default AdminPrivateRoute;
